import axios from '../utils/axios';
import API_URLS from '../constants/api-urls';

const abAvailability = {
    get: (abName: string) => axios.get(`${API_URLS.AB_VARIANT}/${abName}`)
};

export default abAvailability;
